const ProductList = [
  {
    id: '1',
    name: 'Insulin syringe',
    model: '8F-UOG',
    image_url: 'https://cdn.bimedis.com/search/aimage/big/1896812/0/electromyographs-healicom-hem-6600b?iv=1661272547&iv=40441152328396',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L80292.gif',
    price: '$ 20,000',
    available: true,
  },
  {
    id: '2',
    name: 'Fall monitor ',
    model: 'Urit-1600',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/118653-17589173.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L118653.gif',
    price: '$ 30,000',
    available: false,
  },
  {
    id: '3',
    name: 'Automatic',
    model: '8F-5AW',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/79119-17618601.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L79119.gif',
    price: '$ 25,000',
    available: false,
  },
  {
    id: '4',
    name: 'Sliding door',
    model: 'OP750',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/80292-17603042.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L78331.gif',
    price: '$ 78,000',
    available: true,
  },
  {
    id: '5',
    name: 'Insulin',
    model: 'A3',
    image_url: 'https://cdn.bimedis.com/search/aimage/mainPageImage/1904068/eeg-amplifiers-iomed-phoresor-ii',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L80292.gif',
    price: '$ 21,000',
    available: true,
  },
  {
    id: '6',
    name: 'Insulin syringe',
    model: '8F-UOG',
    image_url: 'https://cdn.bimedis.com/search/aimage/big/1896812/0/electromyographs-healicom-hem-6600b?iv=1661272547&iv=40441152328396',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L80292.gif',
    price: '$ 20,000',
    available: true,
  },
  {
    id: '7',
    name: 'Fall monitor ',
    model: 'Urit-1600',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/118653-17589173.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L118653.gif',
    price: '$ 30,000',
    available: false,
  },
  {
    id: '8',
    name: 'Automatic',
    model: '8F-5AW',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/79119-17618601.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L79119.gif',
    price: '$ 25,000',
    available: false,
  },
  {
    id: '9',
    name: 'Sliding door',
    model: 'OP750',
    image_url: 'https://img.medicalexpo.com/images_me/photo-mg/80292-17603042.jpg',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L78331.gif',
    price: '$ 78,000',
    available: true,
  },
  {
    id: '10',
    name: 'Insulin',
    model: 'A3',
    image_url: 'https://cdn.bimedis.com/search/aimage/mainPageImage/1904068/eeg-amplifiers-iomed-phoresor-ii',
    brand: 'https://img.medicalexpo.com/images_me/logo-pp/L80292.gif',
    price: '$ 21,000',
    available: true,
  },
];

export default ProductList;
